// Fetch transfer receipts data
export async function fetchDBTransferReceipts({
  fromAddress,
  toAddress,
  tokenAddress,
  offset = 0,
  limit = 100
}) {
  try {
    const params = new URLSearchParams(Object.assign(Object.assign(Object.assign(Object.assign({}, fromAddress && {
      fromAddress
    }), toAddress && {
      toAddress
    }), tokenAddress && {
      tokenAddress
    }), {
      offset: offset === null || offset === void 0 ? void 0 : offset.toString(),
      limit: limit === null || limit === void 0 ? void 0 : limit.toString()
    }));
    const response = await fetch(`/api/db/transferHistory?${params === null || params === void 0 ? void 0 : params.toString()}`);
    if (!response.ok) {
      return {
        error: 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error fetching transfer receipts data:', error);
    return {
      error: error.message
    };
  }
}
// Create new transfer receipt
export async function createDBTransferReceipt(newTransferReceipt) {
  try {
    const response = await fetch('/api/db/transferHistory', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newTransferReceipt)
    });
    if (!response.ok) {
      return {
        error: 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error creating transfer receipt:', error);
    return {
      error: error.message
    };
  }
}
// Update existing transfer receipt
export async function updateDBTransferReceipt(updatedTransferReceipt) {
  try {
    const response = await fetch('/api/db/transferHistory', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updatedTransferReceipt)
    });
    if (!response.ok) {
      return {
        error: 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error updating transfer receipt:', error);
    return {
      error: error.message
    };
  }
}